import { addToQuery } from 'dpl/util/queryString';
import { ANALYTICS, LITTER_ID, PUPPY_ID } from 'dpl/constants/query_params';

export function getPuppyModalUrl(litterId, puppyId, analytics = {}) {
  const hashParam = addToQuery(
    {
      [ANALYTICS]: analytics,
      [LITTER_ID]: litterId,
      [PUPPY_ID]: puppyId
    },
    window.location.hash
  );
  return `#${hashParam}`;
}

export function getLitterModalUrl(litterId) {
  const hashParam = addToQuery({ [LITTER_ID]: litterId }, window.location.hash);
  return `#${hashParam}`;
}
